module.exports = __webpack_public_path__ + "img/faitsdarmes.2855ac58.png";